/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import ReactGA from "react-ga4";
import {DataLayerItem} from "types/entities/specific/DataLayerItem";
import {GAEventName} from "types/entities/specific/GAEventName";

export const useReactGoogleAnalytics = () => {
    const sendSelectItem = (eventName: GAEventName, dataLayerItems: DataLayerItem[]) => {
        return ReactGA.event(eventName, {
            action: eventName,
            item_list_name: "Booking Packages",
            item_list_id: "booking_packages",
            items: dataLayerItems,
        });
    };

    const sendPurchaseEvent = (transaction_id: number, total: number | null, dataLayerItems: DataLayerItem[]) => {
        ReactGA.event("purchase", {
            action: "purchase",
            category: "Ecommerce",
            currency: "CHF",
            label: "Booking Paid",
            transaction_id: transaction_id,
            value: total ? total / 100 : 0,
            items: dataLayerItems,
        });
    };

    const sendGenericEvent = (eventName: GAEventName, value: number, dataLayerItems: DataLayerItem[]) => {
        switch (eventName) {
            case "select_item":
                return sendSelectItem(eventName, dataLayerItems);
            case "add_payment_info":
            case "add_shipping_info":
            case "add_to_cart":
            case "begin_checkout":
            case "view_item":
            default:
                return ReactGA.event(eventName, {
                    action: eventName,
                    category: "Ecommerce",
                    currency: "CHF",
                    value: value,
                    items: dataLayerItems,
                });
        }
    };

    return {
        sendGenericEvent,
        sendPurchaseEvent,
    };
};
